module.exports = __webpack_public_path__ + "img/map.41ad81cb.webp";